import { gql } from '@apollo/client';

const getMcpCapabilities = gql`
  query GetMcpCapabilities {
    getMcpCapabilities {
      scopes
    }
  }
`;

export default getMcpCapabilities;
